export const ISLAND = {
  title: "Collanmore Island",
  heroImage: "/images/hilltop-sunset.webp",
  introImage: "/images/highest-point-360.jpg",
  gallery: [
    "/images/collanmore-island-aerial.webp",
    "/images/sailing-moorings.webp",
    "/images/island-accom-1.jpg",
    "/images/inish-gort-lighthouse.webp",
    "/images/island-aerial-2.jpg",
  ],
  paragraphs: [
    "Set amidst an archipelago of islands in the heart of Clew Bay, Co Mayo, Collanmore Island is the ultimate west-coast destination for an exclusive island getaway.",
    "Welcome to the largest gem in Clew Bay \u2014 magnificent 700-acre Collanmore Island awaits your exploration and enjoyment!",
    "The island sanctuary boasts clean, sandy beaches, rolling emerald-green hills and a wealth of fascinating wildlife that calls this pristine paradise home. Ascend to the island's highest point and be mesmerised by the breathtaking, uninterrupted 360-degree views of Clew Bay stretching out before you.",
    "If you are staying with us as our guest, you'll enjoy the exclusive use of the island Lodge throughout the duration of your stay. Privacy and space abound, providing the perfect backdrop for your ultimate getaway \u2014 whether you're seeking quiet moments of reflection, thrilling adventures in the great outdoors, or simply the opportunity to unwind and reconnect with nature.",
  ],
};

export const LODGE = {
  title: "The Lodge",
  heroImage: "/images/lodge-hero.jpg",
  mainImage: "/images/lodge-main.jpg",
  tomsBarImage: "/images/cocktail-bar.webp",
  tomsBarImage2: "/images/stags-toms-bar.webp",
  modernImage: "/images/lodge-modern.jpg",
  hotTubImage: "/images/lodge-hottub.jpg",
  nightImage: "/images/lodge-night.webp",
  intro: [
    "Our capable team will coordinate your activity from start to finish, providing you with a safe, seamless and fun adventure activity to remember! The Lodge sleeps 22 people.",
    "Located just 12 minutes from Westport town in Co Mayo, with fantastic access from Rosmoney Pier and only a 2-minute crossing to the island. The 700-acre island is the largest in Clew Bay, with beautiful private beaches.",
  ],
  tomsBar: [
    "Toast with your friends at Tom's Bar in Collanmore Island Lodge \u2014 a replica traditional Irish bar that makes you feel like you've left the house and gone to the pub, without ever leaving the island.",
  ],
  modern: [
    "Enjoy a range of modern conveniences including full kitchen facilities ideal for cooking for large groups, two fridges, freezer, WiFi and smart TV with HDMI, plus exciting features such as a replica traditional Irish bar and outdoor recreation area with fire pit and hammocks.",
    "Unwind in the sauna and soak up magnificent views of Clew Bay in the Lodge's private hot tub. An outdoor bar area can also be set up on request with your own sound speakers and festoon lights.",
  ],
  amenities: [
    "Sleeps 22 guests",
    "Tom's Bar \u2014 replica traditional Irish bar",
    "Full kitchen, two fridges & freezer",
    "WiFi & smart TV with HDMI",
    "Private hot tub & sauna",
    "Fire pit, hammocks & outdoor bar",
    "Private pontoon and beaches",
    "High-speed RIB transfer",
  ],
};

export const GETTING_HERE = {
  title: "Getting Here",
  heroImage: "/images/getting-here-hero.jpg",
  intro:
    "The Adventure Islands Centre \u00B7 Collanmore Island, Clew Bay, Westport, Co Mayo. We are open now for group bookings \u2014 text 086 251 8252 for more info and to book your event.",
  routes: [
    { from: "From Westport", via: "via Golf Course Road", time: "approx. 13 min (8.6 km)" },
    { from: "From Dublin", via: "via N5", time: "approx. 3 hr 22 min (261 km)" },
    { from: "From Belfast", via: "via N5", time: "approx. 4 hr 4 min (190 miles)" },
    { from: "From Galway", via: "via N84", time: "approx. 1 hr 37 min (94 km)" },
    { from: "From Cork", via: "via N20", time: "approx. 3 hr 44 min (293 km)" },
  ],
  crossing:
    "By road: make your way to Rosmoney Pier, then a 2-minute high-speed RIB crossing brings you to Collanmore Island. The crossing is part of the experience.",
};

export const PACKAGES = [
  {
    slug: "corporate",
    name: "Corporate",
    capacity: "20 \u2013 100",
    price: "\u20AC50pp",
    blurb:
      "Collanmore Island Lodge offers a private venue for your exclusive use for the duration of your stay.",
  },
  {
    slug: "schools-youth",
    name: "School and Youth Groups",
    capacity: "20 \u2013 100",
    price: "\u20AC35pp",
    blurb:
      "An exciting and educational experience for your students in the stunning setting of Clew Bay.",
  },
  {
    slug: "hen-stag",
    name: "Hen / Stag Parties",
    capacity: "20 \u2013 100",
    price: "\u20AC50pp",
    blurb:
      "The ideal destination for your next Hen / Stag party \u2014 fun, fitness and feel-good games.",
  },
  {
    slug: "families",
    name: "Families",
    capacity: "4 \u2013 30",
    price: "\u20AC45pp",
    blurb:
      "Tailor-made packages of exhilarating activities and magical moments for the whole family.",
  },
];

export const PACKAGES_INTRO = [
  "Allow us to create a fun, memorable day for your group! Let us tailor the ideal package for your group. Whether it's an exciting Hen & Stag weekend, a memorable birthday celebration for your special someone, or a dynamic team-building day, The Adventure Islands offers a perfect mix of action, fun and adventure, set against a backdrop of breathtaking natural beauty.",
  "Located just 12 minutes from Westport town in Co Mayo, with fantastic access from Rosmoney Pier and only a 2-minute crossing to the island. The Lodge sleeps 22 people and has its own hot tubs and saunas.",
];
